import {
  ChangeDetectionStrategy,
  Component
} from '@angular/core';
import { OrderContentBaseComponent } from '../common/order-content-base.component';

@Component({
  selector: 'ispm-order-content',
  templateUrl: './order-content.component.html',
  styleUrls: ['./order-content.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class OrderContentComponent extends OrderContentBaseComponent { }
